import React from "react";
import {useGlobal} from "reactn";
import {
    RoundedBlockInnerWrapper,
    RoundedBlockItem,
    RoundedBlockItemImage,
    RoundedBlockItemWrapper,
    RoundedBlockWrapper
} from "./RoundedBlock.styles";
import {H2, H4} from "BaseComponents/Text";
import {getResponsiveImage} from "Helpers/ImageHelper";
import {HeaderLinkStyle} from "BaseComponents/Link/BaseLink";
import {ImageWrapperLink} from '../Services/components'
import LazyImage from "../../framework/lazy/LazyImage";
import {GetTextColor} from "Helpers/ColorHelper";

const RoundedCardBody = ({block, backgroundColor}) => {
    const [theme] = useGlobal("theme");
    const bgColorItem = block.BackgroundColor ? `#${block.BackgroundColor}` : undefined;
    const {textColor} = GetTextColor(backgroundColor);
    const Image = getResponsiveImage(block.ResponsiveImage);
    const alt = block.ResponsiveImage.Alt;
    
    const link = block.Link;
    return (<>
        {!!Image.length &&
            <ImageWrapperLink href={link?.Url} Heading={block?.Title ?? link?.name}>
                <RoundedBlockItemImage bgColor={bgColorItem}>
                    <LazyImage source={Image} alt={alt} />                    
                </RoundedBlockItemImage>
            </ImageWrapperLink>}
        {!!block?.Title?.length && !link?.Url?.length && <H4>{block.Title}</H4>}
        {!!block?.Title?.length && !!link?.Url?.length &&
            <HeaderLinkStyle inverted
                             width="fit-content"
                             margin="0"
                             href={link?.Url}
                             text={block.Title}
                             ariaLabel={block.Title}
                             target={link?.Target}
                             textAlign="center"
                             forceFontSize="18px">
                <H4 color={textColor}>{block.Title}</H4>
            </HeaderLinkStyle>
        }
    </>);
}

export const RoundedBlock = ({Title, Items, BackgroundColor, Alias}) => {
    const [theme] = useGlobal("theme");
    const bgColor = BackgroundColor ? `#${BackgroundColor}` : undefined;
    const {textColor} = GetTextColor(BackgroundColor);
    return <RoundedBlockWrapper className={`lg:px-12 ${Alias}`}>
        <RoundedBlockInnerWrapper className={"container mx-auto"} bgColor={bgColor}>
            <H2
                inline
                margin="0"
                marginsmall="0"
                fontWeight="600"
                color={textColor}
            >
                {Title}
            </H2>
            {!!Items?.length && <RoundedBlockItemWrapper>
                {Items.map((block, index) => {
                    return <RoundedBlockItem key={index}>
                        <RoundedCardBody block={block} backgroundColor={BackgroundColor}/>
                    </RoundedBlockItem>
                })}
            </RoundedBlockItemWrapper>
            }
        </RoundedBlockInnerWrapper>
    </RoundedBlockWrapper>
};